import React from 'react';
import logoRepublicaArgentina from '../../assets/images/footer/turismo-argentina.png';
const FooterLogoArgentina = () => {
  return (
    <img src={logoRepublicaArgentina} alt="Republica de la nacion argentina" style={{width: '10rem'}} className='mt-5 footer__mobile-clear' />
  );
};

export default FooterLogoArgentina;